var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-0 ma-0 d-flex flex-column"},[_c(_vm.getEditorComponent(),{ref:"editor",tag:"component",staticClass:"editorComponent pa-0 ma-0 flex-grow-1 flex-shrink-1",attrs:{"context":_vm.getContext()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }